import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { Modal } from 'react-bootstrap';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './Map.css';
import { getMapData } from '../../api';

// Leaflet icon fix for React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const Map = () => {
  const [mapData, setMapData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Türkiye'nin merkez koordinatları
  const turkeyCenter = [39.0, 35.0];
  const defaultZoom = 6;

  useEffect(() => {
    const fetchMapData = async () => {
      try {
        setLoading(true);
        const response = await getMapData();
        console.log('Map API Response:', response);
        
        if (response.status && response.data) {
          // Koordinatlara göre gruplandır
          const groupedData = {};
          
          response.data.forEach(item => {
            const coordKey = `${item.lat},${item.lng}`;
            
            if (!groupedData[coordKey]) {
              groupedData[coordKey] = {
                lat: item.lat,
                lng: item.lng,
                items: []
              };
            }
            
            groupedData[coordKey].items.push(item);
          });
          
          // Gruplanan veriyi array'e çevir
          const processedData = Object.values(groupedData);
          console.log('Grouped map data:', processedData);
          
          setMapData(processedData);
        } else {
          setError('Harita verileri yüklenemedi');
        }
      } catch (err) {
        console.error('Map data fetch error:', err);
        setError('Harita verileri yüklenirken hata oluştu');
      } finally {
        setLoading(false);
      }
    };

    fetchMapData();
  }, []);

  if (loading) {
    return (
      <div className="map-container">
        <div className="map-loading">
          <p>Harita yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="map-container">
        <div className="map-error">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="map-container">
 
      <div className="map-wrapper">
        <MapContainer
          center={turkeyCenter}
          zoom={defaultZoom}
          style={{ height: '600px', width: '100%' }}
          className="leaflet-map"
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          
          {mapData.map((location, index) => (
            <Marker
              key={`${location.lat}-${location.lng}`}
              position={[
                parseFloat(location.lat),
                parseFloat(location.lng)
              ]}
              eventHandlers={{
                click: () => {
                  setSelectedLocation(location);
                  setShowModal(true);
                }
              }}
            />
          ))}
        </MapContainer>
      </div>
      
      {mapData.length === 0 && (
        <div className="map-no-data">
          <p>Haritada gösterilecek veri bulunamadı</p>
        </div>
      )}

      {/* Custom Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton style={{background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)', color: 'white', border: 'none'}}>
          <Modal.Title>
            İstanbul
            <div style={{fontSize: '0.9rem', opacity: 0.9, fontWeight: 400}}>
              {selectedLocation?.items.length} makale • {[...new Set(selectedLocation?.items.map(item => item.writerName) || [])].length} yazar
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{padding: '1.5rem', maxHeight: '400px', overflowY: 'auto'}}>
          {selectedLocation?.items.map((item, idx) => (
            <div key={item.id} 
                 className="modal-item-card" 
                 onClick={() => window.open(`/article/${item.id}`, '_blank')}
                 style={{
                   display: 'flex',
                   alignItems: 'center',
                   gap: '1rem',
                   padding: '1rem',
                   marginBottom: '0.5rem',
                   background: '#ffffff',
                   border: '1px solid #e9ecef',
                   borderRadius: '8px',
                   cursor: 'pointer',
                   transition: 'all 0.2s ease'
                 }}
                 onMouseEnter={(e) => {
                   e.target.style.background = '#f8f9fa';
                   e.target.style.borderColor = '#DC1A22';
                   e.target.style.transform = 'translateX(3px)';
                   e.target.style.boxShadow = '0 3px 10px rgba(220, 26, 34, 0.1)';
                 }}
                 onMouseLeave={(e) => {
                   e.target.style.background = '#ffffff';
                   e.target.style.borderColor = '#e9ecef';
                   e.target.style.transform = 'translateX(0)';
                   e.target.style.boxShadow = 'none';
                 }}>
              <div style={{
                background: '#DC1A22',
                color: 'white',
                width: '28px',
                height: '28px',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.85rem',
                fontWeight: 600,
                flexShrink: 0
              }}>
                {idx + 1}
              </div>
              <div style={{flex: 1, minWidth: 0}}>
                <h6 style={{
                  fontSize: '0.95rem',
                  fontWeight: 600,
                  color: '#2c3e50',
                  margin: '0 0 0.3rem 0',
                  lineHeight: 1.3
                }}>
                  {item.title}
                </h6>
                <div style={{
                  fontSize: '0.85rem',
                  color: '#64748b',
                  fontStyle: 'italic',
                  fontWeight: 500
                }}>
                  {item.writerName}
                </div>
              </div>
              <div style={{
                color: '#DC1A22',
                opacity: 0.6,
                flexShrink: 0
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8.59 16.59L13.17 12L8.59 7.41L10 6l6 6-6 6-1.41-1.41z"/>
                </svg>
              </div>
            </div>
          ))}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Map;